exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.head-bg {\n    background: #68ADFF;\n}\n", ""]);

// exports
